/** События аналитики: окна. */
import { z } from "zod";
import { DailyTaskClaim, FeedbackType } from "../api";
import { PosInt, UInt } from "../common";

export const windowsEvents = [
  /** Нажал «поделиться»: `link` — в обычном браузере, ссылкой (ISSUE-141). */
  z.object({
    name: z.literal("share"),
    props: z.object({ target: z.enum(["chat", "story", "link"]), wave: PosInt }),
  }),
  /** Нажал «Позвать друга»: окно победы над первым боссом или вкладка друзей (ISSUE-136). */
  z.object({ name: z.literal("friend_invite"), props: z.object({ place: z.enum(["boss", "league"]) }) }),
  /** Открыто окно заданий дня. `claimable` — сколько наград можно забрать. */
  z.object({ name: z.literal("tasks_open"), props: z.object({ claimable: UInt }) }),
  /** Забрана награда задания или мешок. */
  z.object({
    name: z.literal("task_claim"),
    props: z.object({ task: DailyTaskClaim, coins: UInt, bestWave: UInt }),
  }),
  /** Показано окно с вопросом, может ли бот писать. */
  z.object({ name: z.literal("write_access_ask"), props: z.object({ wave: PosInt }) }),
  /** Ответ: `prompt` — «Не сейчас» в нашем окне, `telegram` — системное окно. */
  z.object({
    name: z.literal("write_access"),
    props: z.object({ allowed: z.boolean(), via: z.enum(["prompt", "telegram"]) }),
  }),
  /** Показано системное окно «добавить на главный экран». */
  z.object({ name: z.literal("home_screen_ask"), props: z.object({ wave: PosInt }) }),
  /** Ярлык добавлен. */
  z.object({ name: z.literal("home_screen_added"), props: z.object({ wave: PosInt }) }),
  /** Игрок отправил отзыв из игры. Текст и контакт сюда не идут. */
  z.object({ name: z.literal("feedback_sent"), props: z.object({ type: FeedbackType }) }),
] as const;
